import React from "react"
import { graphql } from "gatsby"
import { GatsbyImage } from "gatsby-plugin-image";

import SEO from '../../components/seo'

import Layout from '../../components/layout'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Container from 'react-bootstrap/Container'
import { Carousel } from "react-bootstrap";
import NutritionTable from "../../components/NutritionTable";
import ReactMarkdown from "react-markdown";

import { format } from "date-fns";

export const query = graphql`
  query ProductDetailQuery($name: String!) {
    strapiBatchInformation(name: { eq: $name }) {
      title
      text {
        data {
          text
        }
        medias {
          localFile {
            url
            childImageSharp {
              gatsbyImageData(
                width: 600,
                quality: 80
                )
            }
          }
        }
      }
      images {
        localFile {
          publicURL
          childImageSharp {
            gatsbyImageData(
              width: 1200,
              height: 800,
              backgroundColor: "#fff",
              transformOptions: {cropFocus: CENTER, fit: CONTAIN}
              quality: 80
              )
          }
        }
      }
    }
  }
`;
/*childrenFile {
        url
        childImageSharp {
          gatsbyImageData(
            width: 600,
            quality: 80
            )
        }
      }*/

const IngredientDescription: React.FunctionComponent = (props) => {
  return <>
    <SEO
      title={`Bio.Fair.Direkt. - ${props.data.strapiBatchInformation.title}`}
      description={props.data.strapiBatchInformation.title}
    />
    <Layout>

      <section className="hero pt-5">
        <div className="container">
          <div className="hero-content pt-5 pb-2 text-center">
            <h1 className="mb-5">{props.data.strapiBatchInformation.title}</h1>
            {props.location && props.location.state && props.location.state.batchInfo &&
              <div className="row">
                <div className="col-xl-8 offset-xl-2">
                  <p className="text-muted mb-0">
                    Charge erstellt am <span className="text-muted font-weight-bold">{format(new Date(props.location.state.batchInfo.creationDate.split(' ')[0]), "dd.MM.yyyy")}</span>
                    <span className="mx-1">|</span>
                    Mindestens haltbar bis <span className="text-muted font-weight-bold">{format(new Date(props.location.state.batchInfo.expiryDate), "dd.MM.yyyy")}</span>
                  </p>
                </div>
              </div>
            }
          </div>
        </div>
      </section>

      <section>
        <Container>
          <Row className="mb-5">
            <Col xl={10} className="mx-auto">
              {props.data.strapiBatchInformation.images && props.data.strapiBatchInformation.images.length === 1 &&
                <>
                  {props.data.strapiBatchInformation.images[0].localFile.childImageSharp &&
                    <GatsbyImage
                      image={props.data.strapiBatchInformation.images[0].localFile.childImageSharp.gatsbyImageData}
                      className="img-fluid" />
                  }
                  {!props.data.strapiBatchInformation.images[0].localFile.childImageSharp &&
                    <img src={props.data.strapiBatchInformation.images[0].localFile.publicURL} />
                  }
                </>
              }
              {props.data.strapiBatchInformation.images && props.data.strapiBatchInformation.images.length > 1 &&
                <Carousel variant="dark">
                  {props.data.strapiBatchInformation.images.map((image, index) => (
                    <Carousel.Item key={index}>
                      {image.localFile.childImageSharp &&
                        <GatsbyImage
                          image={image.localFile.childImageSharp.gatsbyImageData}
                        />
                      }
                      {!image.localFile.childImageSharp &&
                        <img src={image.localFile.publicURL} />
                      }
                    </Carousel.Item>
                  ))}
                </Carousel>
              }
            </Col>
          </Row>
          <Row>
            <Col xl={8} lg={10} className="mx-auto">
              <div className="text-content text-lg article-text">
                <ReactMarkdown
                  children={props.data.strapiBatchInformation.text.data.text}
                  components={{
                    img: ({ node, ...imgProps }) => {
                      return (<GatsbyImage image={
                        props.data.strapiBatchInformation.text.medias.find(media => media.localFile.url === imgProps.src).localFile.childImageSharp.gatsbyImageData
                      } />)
                    }
                  }}
                />
              </div>
            </Col>
          </Row>

          {props.location && props.location.state &&
            <Row>
              <Col xl={8} lg={10} className="mx-auto mb-5">
                {props?.location?.state?.batchInfo?.nutritionValues &&
                  <NutritionTable nutritionValues={props.location.state.batchInfo.nutritionValues} />
                }
              </Col>
            </Row>
          }
        </Container>
      </section>

    </Layout>
  </>;
}

export default IngredientDescription
